<template>
	<div class="treemap">
		<div style="aligns-item:center;" >
			<el-select v-model="value" @change="getData" :placeholder="$t('other.a50')">
				<el-option
				v-for="item in options"
				:key="item.value"
				:label="item.label"
				:value="item.value">
				</el-option>
			</el-select>
		</div>
    <div style="display:flex">
      <div id="treeMapDom" style="height: 600px;width:80%" class="border center word">{{$t('other.a2776')}}</div>
      <div class="note">
        <p>{{$t('other.a2777')}}</p>
        <p>{{$t('other.a2778')}}</p>
        <p>{{$t('other.a2779')}}</p>
        <br />
        <p>{{$t('other.a2780')}}</p>
        <p>{{$t('other.a2781')}}</p>
        <p>{{$t('other.a2782')}}</p>
        <p>{{$t('other.a2783')}}</p>
      </div>
    </div>
	</div>
</template>

<script>

	 import * as echarts from 'echarts';
	 import dataJson from './config.js'//th
	 import dataJSON_2 from './config2.js'//my
	 import dataJSON_3 from './config3.js'//ph
	 import dataJSON_4 from './config4.js'//zx
	 import api from '../../api/moudles/userStoreItems'
   import axios from 'axios'



     import { mapState, mapActions } from 'vuex';
	 export default {
	   name: 'HelloWorld',
	   data () {
	     return {
			formatUtil: null,
			chatsRadios:null,
			options: [],
			value: '',
			Date_list:[],
			storeName:'',
			
	     }
	   },
	   computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
				userName: state => state.shopaccess.userInfo.userName,
				userPos: state => state.shopaccess.userInfo.userPos,
			}),
		},
		created(){
			this.options=[]
			JSON.parse(localStorage.getItem('userInfo')).stores.map(p => {
				this.options.push({
					value:p.storeId,
					label:p.storeName + '(' + p.userName +')'
				}) 
			})
			console.log(this.options) 
			this.value=this.options[0].value
			this.getData()
		},
	
	   methods: {
		...mapActions('userStoreItems',[
			'getStoreItem'

		]),
    test(){
			this.Date_list = json5
      this.testD3()
    },
		getData(){
      try {
        axios.post('https://lcwonline.xyz:8020/message/storage/',{store_id:this.value})
          .then(res => {
            this.Date_list=res.data//图表的json数据
            this.testD3()
          })
      } catch (error) {
        this.$message.error(this.$t('other.a2775'))
      }
 







		},

	     testD3(){ 
			 
			  console.log('ABC',this.Date_list)
			  console.log('1111',dataJson)
			  var chartDom = document.getElementById('treeMapDom');
			  var myChart = echarts.init(chartDom);
			  var option=null
			  
			    function colorMappingChange(value) {
			          var levelOption = getLevelOption(value);
			          chart.setOption({
			              series: [{
			                  levels: levelOption
			              }]
			          });
			      }
			  
			      var formatUtil = echarts.format;
				  
				  function getLevelOption() {
				          return [
				              {
				                  itemStyle: {
				                      borderWidth: 0,
				                      gapWidth: 5
				                  }
				              },
				              {
				                  itemStyle: {
				                      gapWidth: 1
				                  }
				              },
				              {
				                  colorSaturation: [0.35, 0.5],
				                  itemStyle: {
				                      gapWidth: 1,
				                      borderColorSaturation: 0.8
				                  }
				              }
				          ];
				      }
			  
			   myChart.setOption(option = {
			   
			           title: {
			               text: this.storeName,
			               left: 'center'
			           },
			   
			           tooltip: {
			               formatter: function (info) {
			                   var value = info.value;
							   var name = info.name;
			                //    var treePathInfo = info.treePathInfo;
			                //    var treePath = [];
			   
			                //    for (var i = 1; i < treePathInfo.length; i++) {
			                //        treePath.push(treePathInfo[i].name);
			                //    }
			   
			                   return [
			                      '<div class="tooltip-title">' + 'itemName: ' + name[1] + '</div>',
								  '<div class="tooltip-title">' + 'Rank: ' + name[0] + '</div>',
								  '<div class="tooltip-title">' + 'Tmp: ' + formatUtil.addCommas(value[0]) + '</div>',
			                   
								   
			                   ].join('');
			               }
			           },
			   
			           series: [
			               {
			                   name: this.storeName,
			                   type: 'treemap',
			                   visibleMin: 5000,
			                   label: {
			                       show: true,
								    formatter: function(a) {
										let str='类别：';
										return str.concat(a.name[0] + '\n\n' + '商品名：', a.name[1]);
									}
			                   },
							   
			                   itemStyle: {
			                       borderColor: '#fff'
			                   },
			                   levels: getLevelOption(),
			                   data: this.Date_list
			               },
						   
			           ]
			       });
			 
			  
			 
			  
			  
			  
		     
	     },
		getShopItems001() {
			const params={
				offset:15,
				page:0,
				userId:'thseller',
				storeId:'',
				sellerId:'thseller',
				cusCode:''
			}

			this.getStoreItem(params).then(data => {
				console.log('data',data)
			}) 
		},

		 
		 
		 
	   }
	 }
</script>

<style lang="scss" scoped>
  @import "~@assets/scss/mixins";
	.treemap{
    .center{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .word{
      font-size: 20px;
      color: #606266;
    }
    .border{
      border: 2px solid #f4f4f4;
    }
		
		.note{
			// position: absolute;
			// padding: 0 20px;
			// width: 30%;
			// overflow: hidden;
			// top:80px;
			// left: 0;
			margin: 50px 50px;

			p{
				line-height: 40px;
			}
		}


	
	}
</style>
